import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useAssignationsCarte = (classeId, refresh) => {
  const enabled = classeId ? undefined : 'not-enabled';
  return useApi(`${url}classes/${classeId}/assignations/`, [], refresh, enabled);
};
